/**
 * Normalise an embed-API font URL to an absolute https URL.
 *
 * The API is inconsistent: dev sends a fully absolute `https://...`, but prod
 * sends a protocol-less `cdnjs.inresi.com/assets/fonts/x.ttf` which, passed
 * straight into `url(...)`, resolves against the embed's own origin and 404s
 * (so the font silently never loads). This normaliser fixes that.
 *
 * Kept DOM-free (no `window`) so it is safe to call during SSR as well as in
 * the browser — the browser caller can pass `window.location.protocol` for
 * protocol-relative `//host/...` URLs; everything else defaults to https.
 */
export function normalizeFontUrl(url: string, protocol = "https:"): string {
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("//")) return `${protocol}${url}`;
  return `https://${url.replace(/^\/+/, "")}`;
}
